import ModpackCarousel from "./ModpackCarousel.jsx";

export default function ModpackCard({ modpack }) {
  return (
    <div className="border rounded-lg shadow-md overflow-hidden hover:shadow-xl transition bg-purple-800">
      <ModpackCarousel images={modpack.images} />
      <div className="p-4">
        <h2 className="text-xl font-semibold inline-block no-underline transition duration-300 hover:text-purple-300 hover:scale-105">
        <a href={`/modpack/${modpack.id}`}>{modpack.name}</a>
        </h2>
        <p className="mt-1 text-white-700 font-bold">IP: {modpack.ip}</p>
        <p className="mt-1 text-white-700 font-semibold">Version: {modpack.version}</p>
        <p className="mt-2 text-white-700">{modpack.short}</p>
      </div>
    </div>
  );
}